<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ShowNotification from '@/components/Notifications/ShowNotification.vue'

export default {
  name: 'NotificationComponent',
  components: { ShowNotification },
  data () {
    return {
      is_loading: false,
      show_modal: false,
      notifications: [],
      selected: null
    }
  },
  watch: {
    show_modal (v) {
      if (v) {
        this.loadNotifications()
      }
    }
  },
  computed: {
    ...mapState('notificationStore', ['count_unread'])
  },
  methods: {
    ...mapActions('notificationStore', ['getNotifications', 'deleteAllNotification']),
    ...mapMutations('notificationStore', ['decrementCount', 'setCountUnread']),
    sendDeleteAllNotifications () {
      this.deleteAllNotification().then(() => {
        this.setCountUnread(0)
        this.show_modal = false
        this.notifications = []
      })
    },
    loadNotifications () {
      this.is_loading = true
      this.getNotifications().then(response => {
        this.notifications = response.data.data
        this.is_loading = false
      })
    },
    selectItem (item) {
      this.selected = item
    },
    notificationRead () {
      this.selected.read_at = true
      this.decrementCount()
    }
  }
}
</script>

<template>
  <v-menu
      v-model="show_modal"
      left
      offset-y
      :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          color="black"
          class="ml-2"
          v-bind="attrs"
          v-on="on"
          fab
          dark
          small
      >
        <v-badge
            :content="count_unread"
            :value="count_unread"
            color="red"
            overlap
        >
          <v-icon dark>
            mdi-bell
          </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card width="400px">
      <v-card-title>Уведомления</v-card-title>
      <v-card-text class="px-0 py-0" style="max-height: 450px; overflow-y: auto" v-if="!is_loading">
      <v-list class="pt-0" three-line>
        <v-list-item
            @click="selectItem(item)"
            v-for="item in notifications"
            :key="item.id"
        >
          <v-list-item-content>
            <div><small>{{ item.created_at | moment('DD.MM.YYYY HH:mm') }}</small></div>
            <v-list-item-title>{{ item.data.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.data.message }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </v-card-text>
      <v-skeleton-loader v-else
          type="article"
      />
      <div class="text-center pb-6" v-if="!is_loading && notifications.length === 0">
        У вас нет новых уведомлений
      </div>
      <v-card-actions v-if="notifications.length">
        <v-btn
            dark
            color="orange"
            @click="sendDeleteAllNotifications()"
        >
          Удалить все
        </v-btn>
      </v-card-actions>
    </v-card>
    <ShowNotification
        :notification="selected"
        @update:notification="e => {selected = e}"
        @notificationRead="notificationRead"
    />
  </v-menu>
</template>

<style scoped>

</style>
